/* eslint-disable jsx-a11y/no-static-element-interactions */
import { border, colors, font, formatFullName, padding, rem, Row, space, unit } from '@zipdrug/ui';
import aphroditePropType from 'aphrodite-prop-type';
import { StyleSheet, css } from 'aphrodite/no-important';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import withRoles from 'hoc/withRoles';
import { Button } from 'antd';
import SettingsTopBarDropdown from 'settings/SettingsTopBarDropdown';
import OtherPgsDropdown from './OtherPgsDropdown';
import withCurrentPharmacy from '../../hoc/withCurrentPharmacy';
import HidePHIButton from '../../ui/HidePHIButton';
import TopBarItem from './TopBarItem';
import { SessionContext } from '../../contexts/SessionContextProvider';
import MemberSearch from './MemberSearch';

export const TopBarHeight = '5rem';

const sx = StyleSheet.create({
  container: {
    ...border.build('bottom', { color: colors.gray87 }),
    ...padding.build(0, rem(unit(space.default) - unit(TopBarItem.padding.horizontal))),
    backgroundColor: colors.white,
    fontSize: font.size.small,
    height: TopBarHeight,
    width: '100%',
  },
  containerGradient: {
    // backgroundImage: 'linear-gradient(to bottom, #F5F5F5 0%, #F0F0F0 100%)',
    backgroundColor: '#F5F5F5',
  },
  itemMargin: {
    marginRight: '12px',
    fontWeight: 'bold',
  },
  adminText: {
    fontSize: '12px',
    fontWeight: 'normal',
  },
});

const TopBar = ({
  currentPharmacy,
  // currentUser,
  onHomeClick,
  // onTasksClick,
  // onOutcomesClick,
  showGradient,
  styles,
  isSystemAdmin,
  isPbsTeam,
  isPharmacyTeam,
  isPharmacistTeam,
  isPbsAdmin,
  hasRole,
}) => {
  const { state } = useContext(SessionContext);
  const { currentUser } = state;
  const currentUserName = currentUser ? formatFullName(currentUser) : null;

  const teamName =
    !hasRole.pharmacistUser && !hasRole.pharmacistAdmin
      ? 'Care Manager'
      : get(currentPharmacy, 'name');
  // const canSeeTasks = isZipdrugUser || (currentPharmacy && currentPharmacy.canAccessTasks);
  const callCenterFeatureFlag = get(currentUser, 'feature_flags.callCenter');

  return (
    <Row
      align="center"
      justify="space-between"
      styles={[sx.container, showGradient ? sx.containerGradient : null, styles]}
    >
      {teamName && (
        <Row align="center" justify="start" style={{ flex: 1 }}>
          <TopBarItem isBrandName text={teamName} />
          <Button type="text" onClick={onHomeClick} className={css(sx.itemMargin)}>
            Home
          </Button>

          {/* {canSeeTasks && <TopBarItem onClick={onTasksClick} styles={sx.itemMargin} text="Tasks" />} */}
          <OtherPgsDropdown
            isPbsTeam={isPbsTeam}
            isSystemAdmin={isSystemAdmin}
            isPharmacyTeam={isPharmacyTeam}
            isPharmacistTeam={isPharmacistTeam}
            isPbsAdmin={isPbsAdmin}
            currentUser={currentUser}
          />
          {/* <TopBarItem onClick={onOutcomesClick} styles={sx.itemMargin} text="OutcomesMTM" /> */}
          <MemberSearch />
        </Row>
      )}
      <Row align="center" justify="end">
        {(isPbsTeam || isPharmacyTeam) && <HidePHIButton styles={sx.itemMargin} />}
        {
          // currentUserName && (
          <SettingsTopBarDropdown
            isPbsTeam={isPbsTeam}
            isSystemAdmin={isSystemAdmin}
            isPharmacyTeam={isPharmacyTeam}
            isPharmacistTeam={isPharmacistTeam}
            currentUser={currentUser}
            currentUserName={currentUserName}
          />
          // )
        }
        {(hasRole.pbsAdmin ||
          isSystemAdmin ||
          hasRole.pharmacistAdmin ||
          hasRole.pharmacyAscAdmin ||
          hasRole.pharmacyBusinessDevAdmin) && <span className={css(sx.adminText)}>Admin</span>}
      </Row>
    </Row>
  );
};

TopBar.propTypes = {
  currentPharmacy: PropTypes.shape({
    name: PropTypes.string.isRequired,
    canAccessTasks: PropTypes.any,
  }),
  currentUser: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    feature_flags: PropTypes.object,
  }),
  hasRole: PropTypes.object,
  isSystemAdmin: PropTypes.bool,
  isPbsTeam: PropTypes.bool,
  isPharmacyTeam: PropTypes.bool,
  isPharmacistTeam: PropTypes.bool,
  isPbsAdmin: PropTypes.bool,
  // onTasksClick: PropTypes.func,
  onHomeClick: PropTypes.func,
  // onOutcomesClick: PropTypes.func.isRequired,
  showGradient: PropTypes.bool,
  styles: aphroditePropType,
};

TopBar.defaultProps = {
  showGradient: true,
};

export default withRoles(withCurrentPharmacy(TopBar));
